import { SafeArea } from "capacitor-plugin-safe-area";
import { useEffect, useMemo, useState } from "react";
export const useSafeArea = () => {
    const [insetTop, setInsetTop] = useState(0);
    const [insetBottom, setInsetBottom] = useState(0);
    useEffect(() => {
        const fetchStatusBarHeight = async () => {
            try {
                const safeArea = await SafeArea.getSafeAreaInsets();
                setInsetTop(safeArea.insets.top);
                setInsetBottom(safeArea.insets.bottom);
            }
            catch (error) {
                console.error("Failed to get status bar height:", error);
            }
        };
        fetchStatusBarHeight();
    }, []);
    return useMemo(() => {
        return { insetTop, insetBottom };
    }, [insetTop, insetBottom]);
};
